import { render } from "./print-stock-transfer.vue?vue&type=template&id=81c38280"
import script from "./print-stock-transfer.vue?vue&type=script&lang=js"
export * from "./print-stock-transfer.vue?vue&type=script&lang=js"

import "./print-stock-transfer.vue?vue&type=style&index=0&id=81c38280&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__